export const FirebaseConfig = {
	"projectId": "demand-door",
	"appId": "1:500758787186:web:08bb6db4c833143ca8beeb",
	"databaseURL": "https://demand-door-default-rtdb.firebaseio.com",
	"storageBucket": "demand-door.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDciOzQGwxq7f_qoBImBjR8x0oY5hSqW44",
	"authDomain": "demand-door.firebaseapp.com",
	"messagingSenderId": "500758787186",
	"measurementId": "G-F9QFJ4Q0BC"
};